import { render, staticRenderFns } from "./StartupGenAIModal.vue?vue&type=template&id=5d9f930a&scoped=true"
import script from "./StartupGenAIModal.vue?vue&type=script&lang=js"
export * from "./StartupGenAIModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f930a",
  null
  
)

export default component.exports